import { IBaseAutomationFormData, ISendMessageFormData } from '@employer/app/components/jobs-automation/job-automation.model'

export interface IUnresponsiveCandidateFormData extends Pick<ISendMessageFormData, 'delayDuration' | 'delayUnits'>, IBaseAutomationFormData {}

export const unresponsiveCandidateDefaults: IUnresponsiveCandidateFormData = {
  enabled: false,
  delayDuration: 3,
  delayUnits: 'days',
}
